import { render, staticRenderFns } from "./POrderModified.vue?vue&type=template&id=2724f43f"
import script from "./POrderModified.vue?vue&type=script&lang=js"
export * from "./POrderModified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports